import { ApyFilterEnum } from "~/types/apy";
import { CreatedDateFilterEnum } from "~/types/createdDate";
import { EndsInFilterEnum } from "~/types/endsIn";
import type { IEventFilters } from "~/types/eventFilters";
import { RoiFilterEnum } from "~/types/roi";

export const allOptionByKey: Partial<Record<keyof IEventFilters, unknown>> = {
  apyFilter: ApyFilterEnum.ALL,
  roiFilter: RoiFilterEnum.ALL,
  createdAt: CreatedDateFilterEnum.ALL,
  endsIn: EndsInFilterEnum.ALL,
};

export const normalizeFilterValue = (key: keyof IEventFilters, value: unknown) =>
  value === allOptionByKey[key] ? undefined : value;

export const stripAllFilterOptions = <T extends Partial<IEventFilters>>(
  filters: T
): T => {
  const out = { ...filters };

  (Object.keys(allOptionByKey) as (keyof IEventFilters)[]).forEach((key) => {
    if (out[key] === allOptionByKey[key]) {
      delete out[key];
    }
  });

  return out;
};
